import { render, staticRenderFns } from "./NoProcessedImages.vue?vue&type=template&id=60765d73"
import script from "./NoProcessedImages.vue?vue&type=script&lang=js"
export * from "./NoProcessedImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports